export default __webpack_public_path__ + "static/media/invite.7a90e450.jpg";